export default "__VITE_ASSET__BgYfnXTD__"